<template>
    <div class="form-group" :class="{ 'has-error': hasError }">
        <label v-if="title" class="control-label" :class="{ 'col-sm-2': horizontal }">{{ title }}</label>
        <div :class="{ 'col-sm-10': horizontal, 'col-sm-offset-2': horizontal && !title }">
            <slot></slot>
            <span class="help-block" v-if="hasError">{{ error }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        form: null,
        title: null,
        field: null,
        horizontal: Boolean,
    },
    computed: {
        hasError() { if (this.form && this.field) return this.form.errors.has(this.field) },
        error() { if (this.form && this.field) return this.form.errors.get(this.field); },
    },
}
</script>
